module.exports = __webpack_public_path__ + "img/s (3).ed15ab2f.png";